import React from 'react';
import { StyledComponent } from '@emotion/styled';
import {
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import styled from './styled';

type LabelProps = {
  color?: string;
} & SpaceProps &
  ColorProps &
  LayoutProps &
  BorderProps &
  PositionProps &
  FlexboxProps &
  TypographyProps;

const Label: StyledComponent<
  LabelProps & React.LabelHTMLAttributes<HTMLLabelElement>
> = styled.label(
  ({ color = 'text' }) => ({
    color,
    position: 'relative',
    padding: 0,
    margin: 0,
  }),
  space,
  color,
  layout,
  border,
  position,
  flexbox,
  typography,
);

export default Label;
